const API_URL = process.env.REACT_APP_API_URL;

export const fetchPlayers = async () => {
  try {
    const response = await fetch(`${API_URL}/players`);
    if (!response.ok) throw new Error("Failed to fetch players");
    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching players: ${error.message}`);
  }
};

export const addPlayer = async (playerData) => {
  try {
    const formattedData = {
      ...playerData,
      age: parseInt(playerData.age),
      clubId: playerData.clubId ? parseInt(playerData.clubId) : null,
      preferredLeg: playerData.preferredLeg || null,
    };

    const response = await fetch(`${API_URL}/players`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formattedData),
    });
    if (!response.ok) throw new Error("Failed to add player");
    return await response.json();
  } catch (error) {
    throw new Error(`Error adding player: ${error.message}`);
  }
};

export const updatePlayer = async (playerId, playerData) => {
  try {
    // Log the data being sent
    console.log("Updating player with ID:", playerId);
    console.log("Update data:", playerData);

    const formattedData = {
      ...playerData,
      age: parseInt(playerData.age),
      clubId: playerData.clubId ? parseInt(playerData.clubId) : null,
      preferredLeg: playerData.preferredLeg || null,
    };

    console.log("Formatted data:", formattedData);

    const response = await fetch(`${API_URL}/players/${playerId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formattedData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Server error response:", errorData);
      throw new Error(errorData.message || "Failed to update player");
    }

    const result = await response.json();
    console.log("Update successful:", result);
    return result;
  } catch (error) {
    console.error("Full error details:", {
      message: error.message,
      stack: error.stack,
      error,
    });
    throw error;
  }
};

export const deletePlayer = async (playerId) => {
  try {
    const response = await fetch(`${API_URL}/players/${playerId}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("Failed to delete player");
    return true;
  } catch (error) {
    throw new Error(`Error deleting player: ${error.message}`);
  }
};
